// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"31c57fa4","880":"31c57fa4"}[chunkId] + ".chunk.css";
};